import React, {useState} from 'react';

import {Button, Modal} from 'antd';
import IconBtn from '../elements/IconBtn';
import {AiOutlineDelete} from 'react-icons/ai';
import Pallet from "../../http_request/Model/pallet/Pallet";
import {getAgainHandler} from "../../store/TableRedux/TableRedux";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";

const DeleteBox = ({rowData}) => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    let {id} = useParams();

    const showModal = () => {
        setOpen(true);
    };

    const handleCancel = () => {
        setOpen(false);
    };


    const onFinish = () => {
        setLoading(true);
        Pallet.request({
            beforeSend: () => {
                 setLoading(true)
            }, success: (result) => {
                setOpen(false)
                toast.success(` حذف با موفقیت انجام شد.`);
                dispatch(getAgainHandler());
            }, error: (error) => {
                toast.error(error.data.message);

            }, final: () => {
               setLoading(false)
            },


        }).addParams({id: rowData.id}).deleteOrderPallet(id)

    };

    return (
        <>
            <IconBtn onClick={showModal} TooltipText='حذف' color='redIconBtn'
            > <AiOutlineDelete size={20}/> </IconBtn>


            <Modal
                open={open}
                title='حذف '
                onCancel={handleCancel}
                footer={[
                    <Button key='back' className='defBtn redBtn' onClick={handleCancel}>
                        انصراف
                    </Button>,
                    <Button key='submit'  type='primary' loading={loading} onClick={onFinish}>
                        حذف
                    </Button>,

                ]}
            >
                آیا برای حذف اطمینان دارید؟


            </Modal>


        </>

    );
};

export default DeleteBox;
